import { TweenLite, Linear, Power3 } from 'gsap'

const DEFAULT_SIZE = 300;
let lastSidesCount = 0;

export default class extends window.PIXI.Graphics
{
    constructor( color, finalSize ){
        super();

        this.color = color;
        this.finalSize = finalSize;

        //this.__simmetricScale = 1;
        this.holeSize = 0;
        this.currentSize = 0;
        this.rotation = Math.random() * 6.28319;
        this.sides =  Math.floor( Math.random()*1000 );
        this.sides = 3 + this.sides % 5;
        while( this.sides === lastSidesCount ){
            this.sides =  Math.floor( Math.random()*1000 );
            this.sides = 3 + this.sides % 5;
        }
        lastSidesCount = this.sides;
        //
        //
        //this.simmetricScale = 0;
        var duration = 5;
        TweenLite.to( this, duration, {
            currentSize: finalSize * DEFAULT_SIZE,
            ease: Power3.easeOut,

        });

        var delay = 0.5;

        TweenLite.to( this, duration-delay, {
            holeSize: finalSize * DEFAULT_SIZE - 40,
            delay,
            ease: Power3.easeOut
        });

        delay = 0;

        TweenLite.to( this, 2, {
            alpha: 0,
            delay: 1,
            ease: /*Power3.easeInOut, //*/Linear.easeNone,
            onComplete: () => {
                this.destroy();
            }
        });
    }

    set currentSize ( v )
    {
        this.__currentSize = v;

        var size = Math.max( v, this.holeSize );
        var holeRadius = this.holeSize*0.5;
        var radius = size * 0.5;
        var finalRadius = holeRadius + (radius-holeRadius)*0.5;
        var thickness = (radius-finalRadius)*2;

        this.clear();

        if( thickness>0 ){
            this.lineStyle(thickness, this.color, 1);

            if( this.sides === 7 ){
                this.drawCircle(0,0, finalRadius);
            }else{
                var angle = 0;
                var ad = 6.28319 / this.sides;
                this.moveTo( Math.cos( angle ) * finalRadius, Math.sin( angle ) * finalRadius );
                angle += ad;
                for(var i=1; i<this.sides; i++){
                    this.lineTo( Math.cos( angle ) * finalRadius, Math.sin( angle ) * finalRadius );
                    angle += ad;
                }
                this.lineTo( Math.cos( 0 ) * finalRadius, Math.sin( 0 ) * finalRadius );
            }
        }
    }
    get currentSize ()
    {
        return this.__currentSize;
    }

    set holeSize ( v )
    {
        this.__holeSize = v;
    }
    get holeSize ()
    {
        return this.__holeSize;
    }

    set borderSize( v )
    {
        this.__borderSize = v;

        this.clear();
        this.lineStyle(v, this.color, 1);
        //this.beginFill(color, 1);
        this.drawCircle(0,0, DEFAULT_SIZE*this.finalSize);
        this.endFill();
    }

    get borderSize()
    {
        return this.__borderSize;
    }

    set simmetricScale( v )
    {
        this.__simmetricScale = v;
        this.scale = new window.PIXI.Point(v,v);
    }
    get simmetricScale()
    {
        return this.__simmetricScale;
    }
}


/** WEBPACK FOOTER **
 ** ./src/js/home/pixi/circle.js
 **/